import { put, call, takeLatest, all } from 'redux-saga/effects';
import { processRequest } from '../../../services/Api';
import { lessonRequestModalActionTypes } from './Constants';
import { processTutoringRequest } from '../../../tutoring/shared/Constants';
import * as lessonRequestActions from './Actions';
import * as errorHandlerActions from '../../errorHandler/Actions';

export default function* () {
	yield all([
		takeLatest(lessonRequestModalActionTypes.GET_BOOKS_FOR_LESSONS, handleGetBooksForLessons),
		takeLatest(lessonRequestModalActionTypes.ADD_LESSON_REQUEST, handleAddLessonRequest),
		takeLatest(lessonRequestModalActionTypes.GET_LESSON_BY_CHAPTER, handleGetLessonByChapter),
		takeLatest(lessonRequestModalActionTypes.GET_SUBJECTS, handleGetSubjects),
		takeLatest(lessonRequestModalActionTypes.GET_SUBJECTS, handleGetSubjects),
		takeLatest(lessonRequestModalActionTypes.GET_AVAILABLE_SLOTS, handleGetSlots),
	]);
}

export function* handleGetBooksForLessons({ payload }) {
	try {
		const { data: id } = payload || {};

		const {
			data: { books_for_lesson },
		} = yield call(processTutoringRequest, `users/${id}/books_for_lessons`, 'GET');
		yield put(lessonRequestActions.getBooksForLessonsSuccess(books_for_lesson));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e));
		yield put(lessonRequestActions.getBooksForLessonsError());
	}
}

export function* handleAddLessonRequest({ payload }) {
	try {
		const { data, callback } = payload || {};
		yield call(processTutoringRequest, 'lesson_requests', 'POST', data);
		if (callback) callback();
		yield put(lessonRequestActions.addLessonRequestSuccess());
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(lessonRequestActions.addLessonRequestError());
	}
}

export function* handleGetLessonByChapter({ payload }) {
	try {
		const { data: queries } = payload || {};
		const { data: lessonData } = yield call(processTutoringRequest, 'lessons', 'GET', queries);
		const { results, total_count } = lessonData || {};
		const lessonByChapter = total_count > 0 && !!results?.length && results[0];
		yield put(lessonRequestActions.getLessonByChapterSuccess(lessonByChapter));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e));
		yield put(lessonRequestActions.getLessonByChapterError());
	}
}

export function* handleGetSubjects() {
	try {
		const { data } = yield call(processRequest, 'subjects', 'GET');
		const { subjects } = data || {};
		yield put(lessonRequestActions.getSubjectsSuccess(subjects));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(lessonRequestActions.getSubjectsError());
	}
}

export function* handleGetSlots({ payload }) {
	try {
		const { data: requestData } = payload || {};
		const { data } = yield call(
			processTutoringRequest,
			'lesson_requests/time_slot_options',
			'GET',
			{ test_date: requestData },
		);
		yield put(lessonRequestActions.getAvailableSlotsSuccess(data));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(lessonRequestActions.getAvailableSlotsError());
	}
}
